import { useEffect } from "react"
import {
  SHARED_MEDICAL_RECORD_EVENTS_STORE_NAME,
  useSharedMedicalRecordEventsStore,
} from "@/modules/patients/stores/useSharedMedicalRecordEventsStore"

export const useSharedMedicalRecordEventsCrossWindowSynchronization = () => {
  useEffect(() => {
    const rehydrateOnExternalStorageWrite = (storageEvent: StorageEvent) => {
      if (storageEvent.key === null || storageEvent.key === SHARED_MEDICAL_RECORD_EVENTS_STORE_NAME) {
        useSharedMedicalRecordEventsStore.persist.rehydrate()
      }
    }

    window.addEventListener("storage", rehydrateOnExternalStorageWrite)
    return () => window.removeEventListener("storage", rehydrateOnExternalStorageWrite)
  }, [])
}
